import React, { useState } from 'react';
import SupportTicketCard from '../components/SupportTicketCard';
import TicketModal from '../components/TicketModal';
import styles from '../styles/Support.module.css';

const initialTickets = [
  {
    id: 101,
    customer: 'Priya Sharma',
    email: 'priya@gmail.com',
    subject: 'Order not received',
    message: 'I placed an order last week but have not received it yet. Please update me on the status.',
    status: 'Open',
    date: '2025-07-01',
  },
  {
    id: 102,
    customer: 'Amit Verma',
    email: 'amitv@example.com',
    subject: 'Wrong item delivered',
    message: 'I received a different product than what I ordered. Kindly assist.',
    status: 'In Progress',
    date: '2025-07-02',
  },
  {
    id: 103,
    customer: 'Sara Khan',
    email: 'sara.khan@mail.com',
    subject: 'Request for invoice',
    message: 'Can you please send me the invoice for my last purchase?',
    status: 'Resolved',
    date: '2025-06-30',
  },
];

const Support = () => {
  const [tickets, setTickets] = useState(initialTickets);
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState('All');
  const [modalTicket, setModalTicket] = useState(null);

  const handleView = (ticket) => setModalTicket(ticket);
  const handleCloseModal = () => setModalTicket(null);
  const handleResolve = (id) => {
    setTickets(tickets.map(t => t.id === id ? { ...t, status: 'Resolved' } : t));
    alert('Ticket marked as resolved!');
  };
  const handleDelete = (id) => {
    if (window.confirm('Delete this ticket?')) {
      setTickets(tickets.filter(t => t.id !== id));
      alert('Ticket deleted!');
    }
  };

  const filteredTickets = tickets.filter(t =>
    (filter === 'All' || t.status === filter) &&
    (t.customer.toLowerCase().includes(search.toLowerCase()) ||
      t.subject.toLowerCase().includes(search.toLowerCase()) ||
      t.message.toLowerCase().includes(search.toLowerCase()))
  );

  return (
    <div className={styles.supportContainer}>
      <div className={styles.headerRow}>
        <h2>Support Tickets</h2>
        <div className={styles.filterRow}>
          <input
            className={styles.searchInput}
            type="text"
            placeholder="Search by customer, subject, or message..."
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
          <select
            className={styles.filterSelect}
            value={filter}
            onChange={e => setFilter(e.target.value)}
          >
            <option value="All">All</option>
            <option value="Open">Open</option>
            <option value="In Progress">In Progress</option>
            <option value="Resolved">Resolved</option>
          </select>
        </div>
      </div>
      <div className={styles.ticketsGrid}>
        {filteredTickets.length === 0 ? (
          <div className={styles.noTickets}>No tickets found.</div>
        ) : (
          filteredTickets.map(ticket => (
            <SupportTicketCard
              key={ticket.id}
              ticket={ticket}
              onView={handleView}
              onResolve={handleResolve}
              onDelete={handleDelete}
            />
          ))
        )}
      </div>
      <TicketModal ticket={modalTicket} onClose={handleCloseModal} />
    </div>
  );
};

export default Support;